import QuizStartingPage from '../../components/pages/QuizStartingPage';
import themes from '../../themes';

export default function QuizStartseite() {
  return <QuizStartingPage station={'quiz'} theme={themes.quiz} />;
}
